/**
 * Returns a short, progress-aware message for the moment a student finishes
 * a step in a course. Tuned to feel earned, not pandering — no exclamation
 * spam, no "great job!". Copy escalates with how far they've come.
 *
 * @param {number} completedAfter Number of steps complete after this advance.
 * @param {number} total Total number of steps in the course.
 * @returns {string}
 */
export function encouragementForAdvance(completedAfter, total) {
  if (!total || total <= 0) return 'Step complete.'
  if (completedAfter >= total) return "Course done — let's see your results."
  const pct = (completedAfter / total) * 100
  if (pct >= 80) return 'One more to go.'
  if (pct >= 50) return 'Past the halfway mark.'
  if (pct >= 25) return "You're rolling."
  if (completedAfter === 1) return 'First step done.'
  return 'Step complete.'
}
